import { Web3Button } from "@web3modal/react";
import { Link } from "react-router-dom";

export default function Home(): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-6">
      <h1 className="text-4xl">Home</h1>
      <Web3Button icon="hide" avatar="hide" balance="show" />
      <div className="flex gap-3 justify-between">
        <Link to="/lol-nft" className="pointer underline">
          Buy LOL NFT →
        </Link>
        <Link to="/lol-token" className="pointer underline">
          Transfer LOL Token →
        </Link>
        <Link to="/market" className="pointer underline">
          Go to Marketplace →
        </Link>
        <Link to="/lol-vesting" className="pointer underline">
          Claim LOL →
        </Link>
      </div>
    </div>
  );
}
